module.exports = __webpack_public_path__ + "img/icon-building-blue.93fa5d48.svg";